'use client'

import {observer, useLocalObservable} from 'mobx-react'
import React, {useEffect} from 'react'
import {useFirstMountState} from 'react-use'

import {getInjection} from '@runlab/di'

import {StoreContext} from '@/src/context/page-store'

import {PageData} from '@/src/core/domain/entities/page/page-data'

import {PageStoreInterface} from '@/src/ports/store/page-store'

export const StoreProvider = observer(
  <T,>({
    children,
    data,
    queryKey,
  }: React.PropsWithChildren & {
    data: Nullable<PageData<T>>
    queryKey: any[]
  }) => {
    const firstMount = useFirstMountState()

    const store = useLocalObservable<PageStoreInterface<T>>(() =>
      getInjection('PageStoreFactory')(data, queryKey),
    )

    useEffect(() => {
      if (!firstMount && data && queryKey) {
        store.setPageData(data, queryKey)
      }
    }, [data, queryKey])

    return <StoreContext value={store}>{children}</StoreContext>
  },
)
